module.exports = __webpack_public_path__ + "static/media/score2.201c7b06.jpg";